import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  TBctxHeaderItem,
  TGenericIssueDTO,
  TRejectReasonSelectionData,
  TRejectReasonSelectionDataV2,
} from '@monorepo/types';
import { BCTXComputationHelper, EventUtil, InputAppAPIHelperUtil } from '@monorepo/utils';
import { TranslateService } from '@ngx-translate/core';
import { CameraService, CAMERA_MODEL, TCameraModel } from '@monorepo/services';
import { FilterRejectV2ListComponent } from '../filter-reject-v2-list/filter-reject-v2-list.component';

@Component({
  selector: 'monorepo-reject-selection-v2',
  templateUrl: './reject-selection-v2.component.html',
  styleUrls: ['./reject-selection-v2.component.scss'],
})
export class RejectSelectionV2Component implements OnInit {
  @Input() isImageCapturingEnabled: boolean = false;
  @Input() bctxHeader: TBctxHeaderItem[] = [];
  @Input() allRejectList: TGenericIssueDTO[] = [];
  @Input() rejectList: TGenericIssueDTO[] = [];
  @Input() selectedRejectList: TGenericIssueDTO[] = [];

  @Output() cancel = new EventEmitter<'CANCEL'>();
  @Output() clearAll = new EventEmitter<'CLEAR_ALL'>();
  @Output() done = new EventEmitter<TRejectReasonSelectionDataV2>();
  @Output() onViewAll = new EventEmitter<string[]>();

  CAMERA_MODEL = CAMERA_MODEL.identity(EventUtil.getBucketIdFromUniqueEventId(BCTXComputationHelper.getUniqueVId()));
  #bucketInfo: TCameraModel['bucketInfo'] = this.CAMERA_MODEL.bucketInfo;

  constructor(
    private inputAppAPIHelperUtil: InputAppAPIHelperUtil,
    private cameraService: CameraService,
    private modalCtrl: ModalController,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {}

  handleCancel() {
    this.cancel.emit('CANCEL');
  }

  async onViewAllClick() {
    const modal = await this.modalCtrl.create({
      component: FilterRejectV2ListComponent,
      componentProps: {
        lists: this.allRejectList,
        preSelectedLists: this.rejectList,
        title: 'operation_or_reject_reason_selection.listOfOperations',
      },
      cssClass: 'm-modal_reject_flow_component',
      backdropDismiss: false,
    });
    await modal.present();
    modal.onDidDismiss().then((res) => {
      if (res.data) {
        const t = res.data as TGenericIssueDTO[];
        this.onViewAll.emit(t.map((x) => x.issueName));
      }
    });
  }

  handleClearAll() {
    console.log('[Clear All clicked]');
    this.selectedRejectList = [];
    this.clearAll.emit('CLEAR_ALL');
  }

  async openCamera() {
    this.cameraService.openModal(this.CAMERA_MODEL).then((v) => {
      console.log('Dismiss Data', v.data);
      if (v.data) this.#bucketInfo = v.data;
    });
  }

  handleDone() {
    if (this.selectedRejectList.length === 0)
      this.inputAppAPIHelperUtil.showPopup(
        this.translate.instant('input_app_common.alert'),
        this.translate.instant('operation_or_reject_reason_selection.alertMessage'),
      );
    else {
      console.log('[FINAL_SELECTED_REJECT_LIST]', this.selectedRejectList);
      this.done.emit({
        rejectedReasons: this.selectedRejectList,
        bucketInfo: this.#bucketInfo,
      });
    }
  }

  handleRejectReasonSelection(selectedList: TGenericIssueDTO[]) {
    this.selectedRejectList = selectedList;
  }
}
